import PropTypes from 'prop-types';

const ConditionalWrapper = ({ useWrapper, renderWrapper, children }) => {
  if (useWrapper) {
    return renderWrapper(children);
  }
  return children;
};

ConditionalWrapper.propTypes = {
  useWrapper: PropTypes.bool.isRequired,
  renderWrapper: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ConditionalWrapper;
